import React from 'react';

export const TimerSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_22886_2200)">
      <path
        d="M13.5631 11.7661L10.7746 9.67474V5.4145C10.7746 4.98614 10.4283 4.63989 9.99995 4.63989C9.57159 4.63989 9.22534 4.98614 9.22534 5.4145V10.0621C9.22534 10.3061 9.33999 10.5361 9.53519 10.6818L12.6335 13.0056C12.773 13.1101 12.9357 13.1605 13.0975 13.1605C13.3338 13.1605 13.5662 13.0543 13.718 12.8499C13.9752 12.5082 13.9055 12.0225 13.5631 11.7661Z"
        fill="currentColor"
      />
      <path
        d="M10 0C4.48566 0 0 4.48566 0 10C0 15.5143 4.48566 20 10 20C15.5143 20 20 15.5143 20 10C20 4.48566 15.5143 0 10 0ZM10 18.4508C5.34082 18.4508 1.54918 14.6592 1.54918 10C1.54918 5.34082 5.34082 1.54918 10 1.54918C14.66 1.54918 18.4508 5.34082 18.4508 10C18.4508 14.6592 14.6592 18.4508 10 18.4508Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default TimerSvg;
